/* eslint-disable camelcase */
export default {
	// 结果单详情
	result_unit_information: '结果单信息',
	result_number: '结果单号',
	applicant_department: '申请人部门',
	service_platform: '业务所属平台',
	business_BG: '业务所属BG',
	compute_time: '计算时间',
	applicant: '申请人',
	state: '状态',
	remark: '备注',
	application_number: '申请单号',
	client_name: '客户名称',
	business_license: '营业执照',
	client_type: '客户类型',
	credit_score: '信用评分',
	credit_rating: '信用等级',
	limit: '额度',
	payment_days: '账期',
	BG: 'BG',
	business_platform: '业务平台',
	application_period_from: '申请时间从',
	application_period_end: '申请时间至',
	norm_information: '指标信息'
};
